__turbopack_context__.v({
  "form-block": "_7vQBa_form-block",
  "form-block--dawn": "_7vQBa_form-block--dawn",
  "form-block--dawn-2": "_7vQBa_form-block--dawn-2",
  "form-block--dusk": "_7vQBa_form-block--dusk",
  "form-block--light-dusk": "_7vQBa_form-block--light-dusk",
  "form-block--midnight": "_7vQBa_form-block--midnight",
  "form-block--midnight-2": "_7vQBa_form-block--midnight-2",
  "form-block--warm-red": "_7vQBa_form-block--warm-red",
  "form-block__form": "_7vQBa_form-block__form",
  "form-block__submit": "_7vQBa_form-block__submit",
  "form-block__success": "_7vQBa_form-block__success",
  "form-block__wrapper": "_7vQBa_form-block__wrapper",
});
